"use strict";

import Page from "./Account.jsx";

export const auth = true;

export const Component = Page;
